// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServicePrices_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /so/additional_service_prices/lista
 * (controllers/so/additional_service_prices.php::lista).
 *
 * Toda linha de preco de adicional visivel ao filtro de franquias corrente,
 * enriquecida com o nome do adicional e a franquia — a tela de gestao.
 */
import type { AdditionalServicePrices_PriceRow } from './AdditionalServicePrices_PriceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type AdditionalServicePrices_ListaResponseDados = AdditionalServicePrices_PriceRow[];

export type AdditionalServicePrices_ListaResponse = ApiResponse<AdditionalServicePrices_ListaResponseDados>;

registerResponseContract('AdditionalServicePrices_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_additional_service_price_id:            { type: 'number',  required: true },
      so_additional_service_price_additional_id: { type: 'number',  required: false },
      so_additional_service_price_franchise_id:  { type: 'number',  required: false },
      so_additional_service_price_price:         { type: 'number',  required: false },
      so_additional_service_price_deadline_days: { type: 'number',  required: false },
      so_additional_service_price_active:        { type: 'number',  required: false },
      so_additional_service_price_created_at:    { type: 'string',  required: false },
      so_additional_service_name:                { type: 'string',  required: false },
      so_additional_service_default_price:       { type: 'number',  required: false },
      so_service_category_name:                  { type: 'string',  required: false },
      franquia:                                  { type: 'string',  required: false },
    },
  },
})
